import { jsx as _jsx } from "react/jsx-runtime";
import { interpolate } from '../interpolate';
import { sanitizeRichText } from '../sanitize';
export function HeadingBlock({ block, vars }) {
    const html = sanitizeRichText(interpolate(block.content ?? '', vars));
    const Tag = block.level === 'h1' ? 'h1' : 'h2';
    const sizeClass = block.level === 'h1'
        ? 'text-3xl font-bold tracking-tight text-slate-900'
        : 'text-xl font-semibold text-slate-900';
    const alignClass = block.textAlign === 'center' ? 'text-center' : 'text-left';
    return (_jsx(Tag, { className: `${sizeClass} ${alignClass} leading-tight`, 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: { __html: html } }));
}
